import { useQuery } from '@tanstack/react-query';

import Axios from '@/lib/axios-instance';

type Props = {
  id: string;
};

export const getQuestion = async (id: string) => {
  try {
    const response = await Axios.get(`/questions/${id}`);

    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(
        `${error.response.data?.meta?.message || 'An error occurred'}`,
      );
    }
    throw new Error(error.message || 'Network Error');
  }
};

export const useGetQuestion = ({ id }: Props) => {
  const question = useQuery({
    queryKey: ['get_single_predefined_question', id],
    queryFn: () => getQuestion(id),
    enabled: !!id,
  });

  return question;
};
